export const ERefundCardTypes = Object.freeze({
    card: 'tejwal',
    cardless: 'tadawul',
})